import { msg } from '@lingui/core/macro';
import type { FieldMetadataMessageDescriptorDef } from './types';

/**
 * Core fields are fields that are guaranteed to be present in all extBATs.
 */
export const coreFields = {
  month: {
    displayName: msg({
      message: 'Month',
      context: 'The display name for the month field',
    }),
    externalDescription: msg({
      message: 'The month the business activity took place.',
      context: 'Month',
    }),
  },
} as const satisfies Record<string, FieldMetadataMessageDescriptorDef>;

// The following fields are not guaranteed to be present in all extBATs, but are
// generic/common fields that are shared by more than one extBAT.

export const descriptionField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Description',
    context: 'The display name for a dimension',
  }),
};

export const ghgCategoryField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'GHG category',
    context: 'The display name for the GHG category field',
  }),
};

export const massField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Weight',
    context: 'The display name for mass quantity field',
  }),
};

export const massUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Raw weight unit',
    context: 'The display name for a dimension',
  }),
};

export const genericUnitField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Unit',
    context: 'The display name for a dimension',
  }),
};
